import { render } from "./selectGoods.vue?vue&type=template&id=9cb11552&scoped=true"
import script from "./selectGoods.vue?vue&type=script&lang=js"
export * from "./selectGoods.vue?vue&type=script&lang=js"

import "./selectGoods.vue?vue&type=style&index=0&id=9cb11552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cb11552"]])

export default __exports__